import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';

import LoginForm from './loginForm';
import Input from '../../components/common/input';

import { loginUser } from '../../actions/session';

const SignIn = (props) => {
  const {
    submitAction
  } = props;

  const dispatch = useDispatch();
  const errors = useSelector((state) => state.session.loginErrors)
  const shouldLockForm = useSelector((state) => state.session.isLoading);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  return (
    <LoginForm
      title="Sign in to my Compass"
      submitLabel="Sign in"
      showForgotPasswordLink
      submitAction={() => submitAction(email, password)}
      disabled={shouldLockForm}
    >
      <Input
        name='email'
        id='email'
        label='Email'
        type='email'
        value={email}
        changeAction={setEmail}
        placeholder='Enter Email'
        autoComplete='username'
        disabled={shouldLockForm}
        errors={errors?.email}
        focusOnError={errors?.email}
      />

      <Input
        name='password'
        id='password'
        label='Password'
        type='password'
        value={password}
        changeAction={setPassword}
        placeholder='Enter Password'
        autoComplete='current-password'
        disabled={shouldLockForm}
        errors={errors?.password}
        focusOnError={!errors?.password}
      />
    </LoginForm>
  );
};

export default SignIn;
